{
  "version": 1,
  "asset_id": "74415014-26c5-4a58-8d52-327a9d2b30a3",
  "project_id": "160b2239-3b67-4000-8b6e-d774982b0968",
  "url": "/__l5e/assets-v1/74415014-26c5-4a58-8d52-327a9d2b30a3/dr-sara-reading-circle.jpg",
  "r2_key": "a/v1/160b2239-3b67-4000-8b6e-d774982b0968/74415014-26c5-4a58-8d52-327a9d2b30a3/dr-sara-reading-circle.jpg",
  "original_filename": "dr-sara-reading-circle.jpg",
  "size": 45160,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T07:26:59Z"
}
